import './components/cf7-google-places-autocomplete';

document.addEventListener('DOMContentLoaded', () => {

	import('./pages/page').then((c) => {
		const p = new c.Page();
		p.pageSetup();
		p.pageReady();
	});

});


